export const logStyles = 'padding: 3px 8px; border-radius: 3px; background: #007def; color: #ffffff';
